import { render, staticRenderFns } from "./PostPartners.vue?vue&type=template&id=b6c35876"
import script from "./PostPartners.vue?vue&type=script&lang=js"
export * from "./PostPartners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports